module.exports = __webpack_public_path__ + "static/worldautism-9e798428d2739c906df4a8196620d566.png";